import { XMarkIcon } from '@heroicons/react/24/outline';
import React from 'react';

interface FailedFilesWarningProps {
    fileNames: string[];
    onDismiss: () => void;
}

const FailedFilesWarning: React.FC<FailedFilesWarningProps> = ({ fileNames, onDismiss }) => (
    <div className="flex items-start gap-2 bg-yellow-50 border border-yellow-200 rounded-md px-3 py-2">
        <div className="flex-1 text-[11px] text-yellow-800">
            <span className="font-semibold">Some files failed to upload:</span>{' '}
            {fileNames.join(', ')}. Your message was sent but these files were not attached.
        </div>
        <button
            type="button"
            onClick={onDismiss}
            className="text-yellow-600 hover:text-yellow-800 flex-shrink-0"
            aria-label="Dismiss warning"
        >
            <XMarkIcon className="w-3.5 h-3.5" />
        </button>
    </div>
);

export { FailedFilesWarning };
